const htmlContainer = document.querySelector('html');
const bodyContainer = document.querySelector('body');
const siteMenu = document.querySelector('.site-menu')
const topMenu = document.querySelector('.top-menu')
const mobileHeader = document.querySelector(".site-header__mobile")
const siteMenuTrigger = document.querySelector('[data-menu-trigger]')
const siteHeaderInner = document.querySelector('.site-header__inner')
const megaMenus = document.querySelectorAll('.mega-menu')
const siteContent = document.querySelector('.site-content')

if (siteMenuTrigger) {
    siteMenuTrigger.addEventListener('click', e => {
        siteHeaderInner.classList.toggle('is-open')
        siteMenuTrigger.classList.toggle('is-open')
        htmlContainer.classList.toggle('mobile-nav-open')
        topMenu.classList.remove('is-off-screen')
        siteMenu.classList.remove('mega-menu-is-open')

        megaMenus.forEach(el => {
            el.classList.remove('is-open')
        })
    })
}

const siteMenuOffset = siteMenu && siteMenu.offsetTop

document.addEventListener('scroll', e => {
    const scrolled = window.pageYOffset

    if (scrolled >= siteMenuOffset) {
        siteMenu.classList.add('is-fixed')
        topMenu.classList.add('is-fixed')
        siteContent.classList.add('site-content--spacing-top')
    }
    else {
        siteMenu.classList.remove('is-fixed')
        topMenu.classList.remove('is-fixed')
        siteContent.classList.remove('site-content--spacing-top')
    }
})